import React from "react";
import { render, screen, fireEvent } from "@testing-library/react";
import "@testing-library/jest-dom";

import { FollowUpSuggestionChips } from "./FollowUpSuggestionChips";

describe("FollowUpSuggestionChips", () => {
  it("renders one button per suggestion inside a labelled group", () => {
    render(
      <FollowUpSuggestionChips
        suggestions={["First?", "Second?", "Third?"]}
        onSelect={jest.fn()}
      />,
    );

    expect(
      screen.getByRole("group", { name: "Suggested follow-up questions" }),
    ).toBeInTheDocument();
    expect(screen.getAllByRole("button")).toHaveLength(3);
  });

  it("passes the clicked suggestion to onSelect", () => {
    const onSelect = jest.fn();
    render(
      <FollowUpSuggestionChips
        suggestions={["First?", "Second?"]}
        onSelect={onSelect}
      />,
    );

    fireEvent.click(screen.getByRole("button", { name: "Second?" }));

    expect(onSelect).toHaveBeenCalledWith("Second?");
  });

  it("renders nothing for an empty list", () => {
    const { container } = render(
      <FollowUpSuggestionChips suggestions={[]} onSelect={jest.fn()} />,
    );

    expect(container).toBeEmptyDOMElement();
  });

  it("disables every chip when disabled", () => {
    render(
      <FollowUpSuggestionChips
        suggestions={["First?", "Second?"]}
        onSelect={jest.fn()}
        disabled
      />,
    );

    screen.getAllByRole("button").forEach((button) => {
      expect(button).toBeDisabled();
    });
  });
});
